<script setup lang="ts">
import { computed } from 'vue';
import type { FieldStatus } from '@/domain';
import Icon from './Icon.vue';
import { PROV } from '@/app/format';

const props = defineProps<{ status: FieldStatus | string; compact?: boolean }>();
const p = computed(() => PROV[props.status as FieldStatus] ?? PROV.proposed);
</script>

<template>
  <span :class="['prov', `prov--${status}`, { 'prov--compact': compact }]" :title="p.hint"><Icon :name="p.icon" /><span>{{ p.label }}</span></span>
</template>
